import { render } from "./disable_employee_modal.vue?vue&type=template&id=4b3a3817"
import script from "./disable_employee_modal.vue?vue&type=script&lang=js"
export * from "./disable_employee_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__